// Invite codes are minted uppercase server-side. Mobile URL inputs, deep-link
// aggregators (Airbridge/Branch) and clipboard normalizers may lowercase the
// path, which then 404s against the backend. Normalize once here so every
// entrypoint (route params, pasted URLs, branch payloads) resolves the same
// document. `.trim()` also strips stray whitespace/newlines from mobile pastes.
const normalizeInviteId = (raw) => {
  if (raw === null || raw === undefined) return null;
  const cleaned = String(raw).trim().toUpperCase();
  return cleaned || null;
};

export const resolveInviteEntry = ({ routeInviteId, branchData = null }) => {
  return normalizeInviteId(
    routeInviteId || branchData?.inviteId || branchData?.invite_id || null
  );
};

export const storePendingInviteId = (inviteId) => {
  const normalized = normalizeInviteId(inviteId);
  if (normalized) {
    localStorage.setItem('pendingInviteId', normalized);
  }
};

export const getPendingInviteId = () => normalizeInviteId(localStorage.getItem('pendingInviteId'));

export const consumePendingInviteId = () => {
  const inviteId = normalizeInviteId(localStorage.getItem('pendingInviteId'));
  localStorage.removeItem('pendingInviteId');
  return inviteId;
};

export const setActiveGuestInviteId = (inviteId) => {
  const normalized = normalizeInviteId(inviteId);
  if (normalized) {
    localStorage.setItem('activeGuestInviteId', normalized);
  }
};

export const getActiveGuestInviteId = () => normalizeInviteId(localStorage.getItem('activeGuestInviteId'));

export const clearActiveGuestInviteId = () => {
  localStorage.removeItem('activeGuestInviteId');
};

export const storePendingHostListingInviteId = (inviteId) => {
  if (inviteId) {
    localStorage.setItem('pendingHostListingInviteId', inviteId);
  }
};

export const storePendingHostListingInviteData = (inviteData) => {
  if (inviteData) {
    localStorage.setItem('pendingHostListingInviteData', JSON.stringify(inviteData));
  }
};

export const getPendingHostListingInviteId = () => localStorage.getItem('pendingHostListingInviteId');

export const getPendingHostListingInviteData = () => {
  try {
    return JSON.parse(localStorage.getItem('pendingHostListingInviteData') || 'null');
  } catch {
    return null;
  }
};

export const clearPendingHostListingInviteId = () => {
  localStorage.removeItem('pendingHostListingInviteId');
  localStorage.removeItem('pendingHostListingInviteData');
};

export const storePendingHostReferralCode = (referralCode) => {
  if (referralCode) {
    localStorage.setItem('pendingHostReferralCode', referralCode);
  }
};

export const getPendingHostReferralCode = () => localStorage.getItem('pendingHostReferralCode');

export const clearPendingHostReferralCode = () => {
  localStorage.removeItem('pendingHostReferralCode');
};

export const storePendingVenueReferralData = (referralData) => {
  if (referralData) {
    localStorage.setItem('pendingVenueReferralData', JSON.stringify(referralData));
  }
};

export const getPendingVenueReferralData = () => {
  try {
    return JSON.parse(localStorage.getItem('pendingVenueReferralData') || 'null');
  } catch {
    return null;
  }
};

export const clearPendingVenueReferralData = () => {
  localStorage.removeItem('pendingVenueReferralData');
};

// =============================================================
// STAFF INVITE TOKEN (venue staff link-based onboarding)
// =============================================================
const PENDING_STAFF_INVITE_KEY = 'pendingStaffInviteToken';

export const storePendingStaffInviteToken = (token) => {
  if (token) {
    localStorage.setItem(PENDING_STAFF_INVITE_KEY, token);
  }
};

export const getPendingStaffInviteToken = () => localStorage.getItem(PENDING_STAFF_INVITE_KEY);

export const consumePendingStaffInviteToken = () => {
  const token = localStorage.getItem(PENDING_STAFF_INVITE_KEY);
  localStorage.removeItem(PENDING_STAFF_INVITE_KEY);
  return token;
};

export const clearPendingStaffInviteToken = () => {
  localStorage.removeItem(PENDING_STAFF_INVITE_KEY);
};